//#region ../src/utils/sha256-hex.ts
/**
* Lowercase hex, and the SHA-256 of bytes as lowercase hex, through
* WebCrypto. One copy for this package and the Tour Viewer (DEC-H3): the
* printed code's identity (`qr-payload/qr-code-id.ts`), a tour archive's
* file hashes and a signing key's fingerprint (tour kit plan K1), and the
* Tour Viewer's file-opened tour key (`tour-file-key.ts`) all call it.
*/
/** Lowercase hex for a byte array. */
function bytesToHex(bytes) {
	let out = "";
	for (const byte of bytes) out += byte.toString(16).padStart(2, "0");
	return out;
}
/**
* The SHA-256 of `data` as 64 lowercase hex digits.
*
* @throws Error when WebCrypto is unavailable (a page served over plain
*   `http:` to a non-localhost host has no `crypto.subtle`).
*/
async function sha256Hex(data) {
	const subtle = globalThis.crypto?.subtle;
	if (subtle === void 0) throw new Error("sha256Hex: Web Crypto is unavailable - hashing needs a secure context (https, or localhost)");
	const bytes = data instanceof ArrayBuffer ? data : Uint8Array.from(data).buffer;
	return bytesToHex(new Uint8Array(await subtle.digest("SHA-256", bytes)));
}
//#endregion
export { bytesToHex, sha256Hex };
